import bdServices125 from '../bd-services125'
import bdServices from '../bd-services'
var FormData = require('form-data')

const turnosServicesIRGE = {}

turnosServicesIRGE.addAutotanque = function (id, pg, empresa, capacidad, claveTurno, turno, fechaReg, fechaReporte, atendido, capacidad82) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)

  let formData = new FormData()
  formData.append('id', id)
  formData.append('pg', pg)
  formData.append('empresa', empresa)
  formData.append('capacidad', capacidad)
  formData.append('claveTurno', claveTurno)
  formData.append('turno', turno)
  formData.append('fechaReg', fechaReg)
  formData.append('fechaReporte', fechaReporte)
  formData.append('atendido', atendido)
  formData.append('capacidad82', capacidad82)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/addRecepcion.php'
    url: '/servidores/irge/sca/turnos/addTurnos.php'
  }

  if (currentUrl === '10.121.40.125') {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  }
}

turnosServicesIRGE.updateNominaciones = function (id, empresa,nominacion) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)

  let formData = new FormData()
  formData.append('id', id)
  formData.append('empresa', empresa)
  formData.append('nominacion', nominacion)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/addRecepcion.php'
    url: '/servidores/irge/sca/turnos/updateNominacion.php'
  }

  if (currentUrl === '10.121.40.125') {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  }
}

turnosServicesIRGE.getData = function(fecha) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  if (currentUrl === '10.121.40.125') {
    return bdServices125.get(`/servidores/irge/sca/turnos/getData.php?fe=${fecha}`)
      .then(res => res.data)
      .catch(e => console.log(e))
  } else {
    return bdServices.get(`/servidores/irge/sca/turnos/getData.php?fe=${fecha}`)
      .then(res => res.data)
      .catch(e => console.log(e))
  }
}

turnosServicesIRGE.borrarData = function() {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  if (currentUrl === '10.121.40.125') {
    return bdServices125.get('/servidores/irge/sca/turnos/deleteData.php')
      .then(res => res.data)
      .catch(e => console.log(e))
  } else {
    return bdServices.get('/servidores/irge/sca/turnos/deleteData.php')
      .then(res => res.data)
      .catch(e => console.log(e))
  }
}

//turnosServicesIRGE.getUnidadNeg_Menor = function() {
turnosServicesIRGE.getUnidadNeg_Menor = function(fecha) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  if (currentUrl === '10.121.40.125') {
    return bdServices125.get(`/servidores/irge/sca/turnos/getUnidadNegMenor.php?fe=${fecha}`)
      .then(res => res.data)
      .catch(e => console.log(e))
  } else {
    return bdServices.get(`/servidores/irge/sca/turnos/getUnidadNegMenor.php?fe=${fecha}`)
      .then(res => res.data)
      .catch(e => console.log(e))
  }
}

turnosServicesIRGE.crearTurno = function(libres, fecha) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  
  let formData = new FormData()
  formData.append('libres', libres)
  formData.append('fe', fecha)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/addRecepcion.php'
    url: '/servidores/irge/sca/turnos/crearTurno.php'
  }

  if (currentUrl === '10.121.40.125') {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  }
}

turnosServicesIRGE.crearTurnoNuevo = function(fecha) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  
  let formData = new FormData()
  formData.append('fe', fecha)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/addRecepcion.php'
    url: '/servidores/irge/sca/turnos/crearTurnoNuevo.php'
  }

  if (currentUrl === '10.121.40.125') {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  }
}

turnosServicesIRGE.getTurno = function() {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  if (currentUrl === '10.121.40.125') {
    return bdServices125.get('/servidores/irge/sca/turnos/getTurno.php')
      .then(res => res.data)
      .catch(e => console.log(e))
  } else {
    return bdServices.get('/servidores/irge/sca/turnos/getTurno.php')
      .then(res => res.data)
      .catch(e => console.log(e))
  }
}



turnosServicesIRGE.asignarTurno = function(claveTurno, turno, unidadNeg) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)

  let formData = new FormData()
  formData.append('ct', claveTurno)
  formData.append('t', turno)
  formData.append('uN', unidadNeg)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/addRecepcion.php'
    url: '/servidores/irge/sca/turnos/asignarTurno.php'
  }

  if (currentUrl === '10.121.40.125') {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  }
}

turnosServicesIRGE.getAutotanques_unidadNeg = function(unidadNeg, fecha) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  if (currentUrl === '10.121.40.125') {
    return bdServices125.get(`/servidores/irge/sca/turnos/get_unidadNeg.php?uN=${unidadNeg}&fe=${fecha}`)
      .then(res => res.data)
      .catch(e => console.log(e))
  } else {
    return bdServices.get(`/servidores/irge/sca/turnos/get_unidadNeg.php?uN=${unidadNeg}&fe=${fecha}`)
      .then(res => res.data)
      .catch(e => console.log(e))
  }
}

turnosServicesIRGE.getSurtido = function() {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  if (currentUrl === '10.121.40.125') {
    return bdServices125.get('/servidores/irge/sca/turnos/getSurtido.php')
      .then(res => res.data)
      .catch(e => console.log(e))
  } else {
    return bdServices.get('/servidores/irge/sca/turnos/getSurtido.php')
      .then(res => res.data)
      .catch(e => console.log(e))
  }
}

turnosServicesIRGE.getNominacionUN = function(uN, fe) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  if (currentUrl === '10.121.40.125') {
    return bdServices125.get(`/servidores/irge/sca/turnos/getNominacion_uN.php?uN=${uN}&fe=${fe}`)
      .then(res => res.data)
      .catch(e => console.log(e))
  } else {
    return bdServices.get(`/servidores/irge/sca/turnos/getNominacion_uN.php?uN=${uN}&fe=${fe}`)
      .then(res => res.data)
      .catch(e => console.log(e))
  }
}

turnosServicesIRGE.obtenerNominacionFecha = function(fecha) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  if (currentUrl === '10.121.40.125') {
    return bdServices125.get(`/servidores/irge/sca/turnos/getNominaciones_Fecha.php?fe=${fecha}`)
      .then(res => res.data)
      .catch(e => console.log(e))
  } else {
    return bdServices.get(`/servidores/irge/sca/turnos/getNominaciones_Fecha.php?fe=${fecha}`)
      .then(res => res.data)
      .catch(e => console.log(e))
  }
}
turnosServicesIRGE.obtenerNominacionesMes = function(fechaI, fechaF, uN) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  if (currentUrl === '10.121.40.125') {
    return bdServices125.get(`/servidores/irge/sca/turnos/getNominaciones_Mes.php?feI=${fechaI}&feF=${fechaF}&uN=${uN}`)
      .then(res => res.data)
      .catch(e => console.log(e))
  } else {
    return bdServices.get(`/servidores/irge/sca/turnos/getNominaciones_Mes.php?feI=${fechaI}&feF=${fechaF}&uN=${uN}`)
      .then(res => res.data)
      .catch(e => console.log(e))
  }
}

turnosServicesIRGE.updateNewNominacion = function(empresa, nominacion, fechaNom) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)

  let formData = new FormData()
  formData.append('empresa', empresa)
  formData.append('nominacion', nominacion)
  formData.append('fechaNom', fechaNom)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/addRecepcion.php'
    url: '/servidores/irge/sca/turnos/updateNewNominacion.php'
  }

  if (currentUrl === '10.121.40.125') {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  }
}

turnosServicesIRGE.guardarNom_Mensual = function(id, unidadNeg, year, mes, nominacion) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)

  let formData = new FormData()
  formData.append('id', id)
  formData.append('unidadNeg', unidadNeg)
  formData.append('year', year)
  formData.append('mes', mes)
  formData.append('nominacion', nominacion)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/addRecepcion.php'
    url: '/servidores/irge/sca/turnos/guardarNominacionMensual.php'
  }

  if (currentUrl === '10.121.40.125') {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  }
}

turnosServicesIRGE.guardarNom_Diaria = function(id, unidadNeg, nominacion, fechaNom) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)

  let formData = new FormData()
  formData.append('id', id)
  formData.append('unidadNeg', unidadNeg)
  formData.append('nominacion', nominacion)
  formData.append('fechaNom', fechaNom)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/addRecepcion.php'
    url: '/servidores/irge/sca/turnos/guardarNominacionDiaria.php'
  }

  if (currentUrl === '10.121.40.125') {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  }
}



turnosServicesIRGE.getSurtidoUN = function(uN, fe) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  if (currentUrl === '10.121.40.125') {
    return bdServices125.get(`/servidores/irge/sca/turnos/getSurtido_uN.php?uN=${uN}&fe=${fe}`)
      .then(res => res.data)
      .catch(e => console.log(e))
  } else {
    return bdServices.get(`/servidores/irge/sca/turnos/getSurtido_uN.php?uN=${uN}&fe=${fe}`)
      .then(res => res.data)
      .catch(e => console.log(e))
  }
}

turnosServicesIRGE.getNominacionesMensual = function() {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  if (currentUrl === '10.121.40.125') {
    return bdServices125.get(`/servidores/irge/sca/turnos/getNominacionesMensuales.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
  } else {
    return bdServices.get(`/servidores/irge/sca/turnos/getNominacionesMensuales.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
  }
}

turnosServicesIRGE.guardarCambioNominacion = function(id, unidadNeg, valorAnt, valorNuevo, id_usuario, nombre__usuario, fecha_registro) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)

  let formData = new FormData()
  formData.append('i', id)
  formData.append('uN', unidadNeg)
  formData.append('vA', valorAnt)
  formData.append('vN', valorNuevo)
  formData.append('idU', id_usuario)
  formData.append('nU', nombre__usuario)
  formData.append('fR', fecha_registro)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/addRecepcion.php'
    url: '/servidores/irge/sca/turnos/guardarCambio_Nominacion.php'
  }

  if (currentUrl === '10.121.40.125') {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  }
}

turnosServicesIRGE.pausarTurno = function(claveTurno) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)

  let formData = new FormData()
  formData.append('ct', claveTurno)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/addRecepcion.php'
    url: '/servidores/irge/sca/turnos/pausarTurno.php'
  }

  if (currentUrl === '10.121.40.125') {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  }
}

turnosServicesIRGE.quitarPausa = function(claveTurno) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)

  let formData = new FormData()
  formData.append('ct', claveTurno)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/addRecepcion.php'
    url: '/servidores/irge/sca/turnos/quitarPausa.php'
  }

  if (currentUrl === '10.121.40.125') {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  }
}

turnosServicesIRGE.eliminar_ClaveTurno = function(claveTurno) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)

  let formData = new FormData()
  formData.append('ct', claveTurno)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/addRecepcion.php'
    url: '/servidores/irge/sca/turnos/deleteTurnos.php'
  }

  if (currentUrl === '10.121.40.125') {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  }
}

turnosServicesIRGE.eliminar_PG_ClaveTurno = function(pg, claveTurno) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)

  let formData = new FormData()
  formData.append('pg', pg)
  formData.append('ct', claveTurno)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/addRecepcion.php'
    url: '/servidores/irge/sca/turnos/deleteTurnos_PG_CT.php'
  }

  if (currentUrl === '10.121.40.125') {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  }
}

turnosServicesIRGE.darTurno = function(unidadNeg, claveTurno, fecha) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)

  let formData = new FormData()
  formData.append('uN', unidadNeg)
  formData.append('cT', claveTurno)
  formData.append('fe', fecha)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/addRecepcion.php'
    url: '/servidores/irge/sca/turnos/darTurno.php'
  }

  if (currentUrl === '10.121.40.125') {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  }
}

turnosServicesIRGE.getPg_CT = function(cT) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  if (currentUrl === '10.121.40.125') {
    return bdServices125.get(`/servidores/irge/sca/turnos/getPG_CT.php?cT=${cT}`)
      .then(res => res.data)
      .catch(e => console.log(e))
  } else {
    return bdServices.get(`/servidores/irge/sca/turnos/getPG_CT.php?cT=${cT}`)
      .then(res => res.data)
      .catch(e => console.log(e))
  }
}

turnosServicesIRGE.updateDataTurno = function(id, claveTurno, pg, uN, capacidad, capacidad82) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)

  let formData = new FormData()
  formData.append('id', id)
  formData.append('cT', claveTurno)
  formData.append('pg', pg)
  formData.append('uN', uN)
  formData.append('cap', capacidad)
  formData.append('cap82', capacidad82)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/addRecepcion.php'
    url: '/servidores/irge/sca/turnos/updateTurno.php'
  }

  if (currentUrl === '10.121.40.125') {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  }
}
turnosServicesIRGE.updateTurno_PG = function(cTOld, cTNew, pgOld, pgNew, uN, capacidad, capacidad82) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)

  let formData = new FormData()
  formData.append('cTOld', cTOld)
  formData.append('cTNew', cTNew)
  formData.append('pgOld', pgOld)
  formData.append('pgNew', pgNew)
  formData.append('uN', uN)
  formData.append('cap', capacidad)
  formData.append('cap82', capacidad82)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/addRecepcion.php'
    url: '/servidores/irge/sca/turnos/updateTurno_Pg.php'
  }

  if (currentUrl === '10.121.40.125') {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  }
}
turnosServicesIRGE.finalizar_jornada = function(fecha, fechaNew) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)

  let formData = new FormData()
  formData.append('fe', fecha)
  formData.append('feNew', fechaNew)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/addRecepcion.php'
    url: '/servidores/irge/sca/turnos/finalizar_jornada.php'
  }

  if (currentUrl === '10.121.40.125') {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  }
}



export default turnosServicesIRGE


// WEBPACK FOOTER //
// ./src/services/irge/turnosIRGE.js